import { useEffect, useRef } from 'react';
/**
 * Custom hook for debouncing values
 * @param callback - Function to be executed after the delay
 * @param value - Value to be observed
 * @param delay - Delay time in milliseconds (default: 500ms)
 */
export var useDebounce = function (callback, value, delay) {
    if (delay === void 0) { delay = 500; }
    var timeoutRef = useRef();
    useEffect(function () {
        // Clear any existing timeout before setting a new one
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
        timeoutRef.current = setTimeout(function () {
            callback(value);
        }, delay);
        return function () {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, [callback, value, delay]);
};
